export default "__VITE_ASSET__BAo2HtKE__"